<div class="arrowBtn d-none d-md-inline">
  <a (click)="goBack()" class="btn btn-outline-dark">
    <i class="bi bi-arrow-left arrowIcon"></i>
  </a>
</div>

<div class="container">
  <div class="row">
    <div class="col-12 p-2 text-center">
      <h2 class="inline-bordered">
        {{systemInfo.stepOne.system_name}}
      </h2>
    </div>

    <div class="col-12 fst-italic text-center p-1 p-md-3 p-lg-4">
      {{systemInfo.stepOne!.system_description}}
    </div>

    <div class="col-12 col-md-6 text-center mt-2">
      <span class="fst-italic">{{"SYSTEM.SYSTEMMANAGEMENT.MANDATORY" | translate}}<sup>*</sup></span>
    </div>

    <div class="col-12 col-md-6 text-center mt-2">
      <span class="fw-bold">
        {{"SYSTEM.SYSTEMMANAGEMENT.STATUS" | translate}}:
      </span>
      <span *ngIf="systemStatusList.length > 0" class="ms-1">
        <i class="bi bi-circle-fill" style="font-size: large;" [ngStyle]="{'color':  '#'+systemStatusList[0].color}">
        </i>
      </span>
      <span *ngIf="systemStatusList.length > 0" class="ms-1">
        {{systemStatusList[0].name}}
      </span>
    </div>

    <div class="col-12 p-0">
      <mat-stepper *ngIf="stepStatusList.length > 0" orientation="vertical" [linear]="false" #stepper>

        <mat-step errorMessage="Incomplete">
          <ng-template matStepLabel>
            <span style="font-weight: bold;">{{"SYSTEM.SYSTEMMANAGEMENT.SYSANDCUSTINFO" | translate}}</span>
            <span class="ms-4">
              <i *ngIf="stepStatusList[0].listStepStatus[0].idstepstatus == 10" class="bi bi-exclamation-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[0].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[0].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[0].listStepStatus[0].idstepstatus == 15" class="bi bi-check-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[0].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[0].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[0].listStepStatus[0].idstepstatus == 5" class="bi bi-question-circle-fill"
                style="font-size: large;" [ngStyle]="{'color': '#'+stepStatusList[0].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[0].listStepStatus[0].name}}">
              </i>
            </span>
          </ng-template>
          <app-error-message *ngIf="stepStatusList[0].listStepStatus[0].idstepstatus == 10"
            [error]="stepStatusList[0].listStepStatus">
          </app-error-message>
          <app-step-one-readonly *ngIf="!(stepStatusList[0].listStepStatus[0].idstepstatus == 10
          && systemStatusList[0]?.id == 7); else stepOneModify" #stepOne (formEmit)="onFormOneReceived($event)"
            (nextStep)="stepper.next()" [idsystem]="idsystem" [countriesList]="countriesList"
            [stepOne]="systemInfo.stepOne">
          </app-step-one-readonly>
          <ng-template #stepOneModify>
            <!-- <app-error-message [error]="stepStatusList[0].listStepStatus">
            </app-error-message> -->
            <app-step-one #stepOne (formEmit)="onFormOneReceived($event)" (nextStep)="stepper.next()"
              [isReadonly]="true" [idsystem]="idsystem" (readonlyEmit)="onDataReceived()">
            </app-step-one>
          </ng-template>
        </mat-step>

        <mat-step errorMessage="Incomplete">
          <ng-template matStepLabel>
            <span style="font-weight: bold;">
              {{"SYSTEM.SYSTEMMANAGEMENT.INSTALLATIONSITE" | translate}}
            </span>
            <span class="ms-4">
              <i *ngIf="stepStatusList[1].listStepStatus[0].idstepstatus == 10" class="bi bi-exclamation-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[1].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[1].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[1].listStepStatus[0].idstepstatus == 15" class="bi bi-check-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[1].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[1].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[1].listStepStatus[0].idstepstatus == 5" class="bi bi-question-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[1].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[1].listStepStatus[0].name}}">
              </i>
            </span>
          </ng-template>
          <ng-template matStepContent>
            <app-error-message *ngIf="stepStatusList[1].listStepStatus[0].idstepstatus == 10"
              [error]="stepStatusList[1].listStepStatus">
            </app-error-message>
            <app-step-two-readonly *ngIf="!(stepStatusList[1].listStepStatus[0].idstepstatus == 10
             && systemStatusList[0]?.id == 7); else stepTwoModify" #stepTwo (formEmit)="onFormTwoReceived($event)"
              (nextStep)="stepper.next()" [countriesList]="countriesList" [idsystem]="idsystem"
              [stepTwo]="systemInfo.stepTwo">
            </app-step-two-readonly>
            <ng-template #stepTwoModify>
              <!-- <app-error-message [error]="stepStatusList[1].listStepStatus">
              </app-error-message> -->
              <app-step-two #stepTwo (formEmit)="onFormTwoReceived($event)" (nextStep)="stepper.next()"
                [idsystem]="idsystem" [isReadonly]="true" (readonlyEmit)="onDataReceived()">
              </app-step-two>
            </ng-template>
          </ng-template>

        </mat-step>

        <mat-step errorMessage="Incomplete">
          <ng-template matStepLabel>
            <span style="font-weight: bold;">
              {{"SYSTEM.SYSTEMMANAGEMENT.TECHNICIANINFO" | translate}}
            </span>
            <span class="ms-4">
              <i *ngIf="stepStatusList[2].listStepStatus[0].idstepstatus == 10" class="bi bi-exclamation-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[2].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[2].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[2].listStepStatus[0].idstepstatus == 15" class="bi bi-check-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[2].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[2].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[2].listStepStatus[0].idstepstatus == 5" class="bi bi-question-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[2].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[2].listStepStatus[0].name}}">
              </i>
            </span>
          </ng-template>
          <ng-template matStepContent>
            <app-error-message *ngIf="stepStatusList[2].listStepStatus[0].idstepstatus == 10"
            [error]="stepStatusList[2].listStepStatus">
            </app-error-message>
            <app-step-three-readonly *ngIf="!(stepStatusList[2].listStepStatus[0].idstepstatus == 10
              && systemStatusList[0]?.id == 7); else stepThreeModify" #stepThree
              (formEmit)="onFormThreeReceived($event)" (nextStep)="stepper.next()" [stepThree]="systemInfo.stepThree"
              [countriesList]="countriesList" [idsystem]="idsystem">
            </app-step-three-readonly>
            <ng-template #stepThreeModify>
              <!-- <app-error-message [error]="stepStatusList[2].listStepStatus">
              </app-error-message> -->
              <app-step-three #stepThree (formEmit)="onFormThreeReceived($event)" (readonlyEmit)="onDataReceived()"
                (nextStep)="stepper.next()" [idsystem]="idsystem" [isReadonly]="true">
              </app-step-three>
            </ng-template>
          </ng-template>
        </mat-step>

        <mat-step errorMessage="Incomplete">
          <ng-template matStepLabel>
            <span style="font-weight: bold;">
              {{"SYSTEM.SYSTEMMANAGEMENT.DEVICESINFO" | translate}}
            </span>
            <span class="ms-4">
              <i *ngIf="stepStatusList[3].listStepStatus[0].idstepstatus == 10" class="bi bi-exclamation-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[3].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[3].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[3].listStepStatus[0].idstepstatus == 15" class="bi bi-check-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[3].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[3].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[3].listStepStatus[0].idstepstatus == 5" class="bi bi-question-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[3].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[3].listStepStatus[0].name}}">
              </i>
            </span>
          </ng-template>
          <ng-template matStepContent>
            <app-error-message *ngIf="stepStatusList[3].listStepStatus[0].idstepstatus == 10"
            [error]="stepStatusList[3].listStepStatus">
            </app-error-message>
            <app-step-four-readonly *ngIf="!(stepStatusList[3].listStepStatus[0].idstepstatus == 10
            && systemStatusList[0]?.id == 7 ); else stepFourModify" #stepFour (formEmit)="onFormFourReceived($event)"
              (nextStep)="stepper.next()" [stepFour]="systemInfo.stepFour" [idsystem]="idsystem">
            </app-step-four-readonly>
            <ng-template #stepFourModify>
              <!-- <app-error-message [error]="stepStatusList[3].listStepStatus">
              </app-error-message> -->
              <app-step-four #stepFour (formEmit)="onFormFourReceived($event)" (nextStep)="stepper.next()"
                [idsystem]="idsystem" [isReadonly]="true" (readonlyEmit)="onDataReceived()">
              </app-step-four>
            </ng-template>
          </ng-template>
        </mat-step>

        <mat-step errorMessage="Incomplete">
          <ng-template matStepLabel>
            <span style="font-weight: bold;">
              {{"SYSTEM.SYSTEMMANAGEMENT.INVERTER" | translate}}
            </span>
            <span class="ms-4">
              <i *ngIf="stepStatusList[4].listStepStatus[0].idstepstatus == 10" class="bi bi-exclamation-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[4].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[4].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[4].listStepStatus[0].idstepstatus == 15" class="bi bi-check-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[4].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[4].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[4].listStepStatus[0].idstepstatus == 5" class="bi bi-question-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[4].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[4].listStepStatus[0].name}}">
              </i>
            </span>
          </ng-template>
          <ng-template matStepContent>
            <app-error-message *ngIf="stepStatusList[4].listStepStatus[0].idstepstatus == 10" [error]="stepStatusList[4].listStepStatus">
            </app-error-message>
            <app-step-five-readonly *ngIf="!(stepStatusList[4].listStepStatus[0].idstepstatus == 10
            && systemStatusList[0]?.id == 7); else stepFiveModify" #stepFive (formEmit)="onFormFiveReceived($event)"
              (nextStep)="stepper.next()" [stepFive]="systemInfo.stepFive" [idsystem]="idsystem">
            </app-step-five-readonly>
            <ng-template #stepFiveModify>
              <!-- <app-error-message [error]="stepStatusList[4].listStepStatus">
              </app-error-message> -->
              <app-step-five #stepFive (formEmit)="onFormFiveReceived($event)" (nextStep)="stepper.next()"
                [idsystem]="idsystem" [isReadonly]="true" (readonlyEmit)="onDataReceived()">
              </app-step-five>
            </ng-template>
          </ng-template>
        </mat-step>

        <mat-step *ngIf="systemInfo.stepFour.product_systemcomposition == 3 && stepStatusList.length > 4
          && stepStatusList[5].listStepStatus.length > 0" errorMessage="Incomplete">
          <ng-template matStepLabel>
            <span style="font-weight: bold;">
              {{"SYSTEM.SYSTEMMANAGEMENT.BATTERIES" | translate}}
            </span>
            <span class="ms-4">
              <i *ngIf="stepStatusList[5].listStepStatus[0].idstepstatus == 10" class="bi bi-exclamation-circle-fill"
                style="font-size: large;" [ngStyle]="{'color':  '#'+stepStatusList[5].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[5].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[5] && stepStatusList[5].listStepStatus[0].idstepstatus == 15"
                class="bi bi-check-circle-fill" style="font-size: large;"
                [ngStyle]="{'color':  '#'+stepStatusList[5].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[5].listStepStatus[0].name}}">
              </i>
              <i *ngIf="stepStatusList[5] && stepStatusList[5].listStepStatus[0].idstepstatus == 5"
                class="bi bi-question-circle-fill" style="font-size: large;"
                [ngStyle]="{'color':  '#'+stepStatusList[5].listStepStatus[0].color}"
                matTooltip="{{stepStatusList[5].listStepStatus[0].name}}">
              </i>
            </span>
          </ng-template>
          <ng-template matStepContent>
            <app-error-message *ngIf="stepStatusList[5].listStepStatus[0].idstepstatus == 10"
             [error]="stepStatusList[5].listStepStatus">
            </app-error-message>
            <app-step-six-readonly *ngIf="!(stepStatusList[5].listStepStatus[0].idstepstatus == 10
            && systemStatusList[0]?.id == 7); else stepSixModify" #stepSix (formEmit)="onFormSixReceived($event)"
              (nextStep)="stepper.next()" [stepSix]="systemInfo.stepSix" [idsystem]="idsystem">
            </app-step-six-readonly>
            <ng-template #stepSixModify>
              <app-error-message [error]="stepStatusList[5].listStepStatus">
              </app-error-message>
              <app-step-six #stepSix (formEmit)="onFormSixReceived($event)" (nextStep)="stepper.next()"
                [idsystem]="idsystem" [isReadonly]="true" (readonlyEmit)="onDataReceived()">
              </app-step-six>
            </ng-template>
          </ng-template>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
  <div class="row justify-content-center" *ngIf="systemStatusList[0]?.id == 7">
    <div class="col-12 text-center mt-1">
      <button class="btn btn-outline-dark mb-2" (click)="readOnly()">
        {{"SYSTEM.SYSTEMMANAGEMENT.OVERVIEW" | translate}}
      </button>
    </div>
    <div class="col-12 text-center mt-1">
      <button class="btn btn-outline-dark ms-2" (click)="approvalRequested()">
        {{"SYSTEM.STEPBUTTONS.SEND" | translate}}
      </button>
    </div>
  </div>

  <div *ngIf="systemStatusList.length > 0 && systemStatusList[0].id == 15"
    class="row justify-content-center align-items-center">
    <div class="col-12 text-center mb-2 mt-3">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 text-center" style="font-weight: bold; font-size: large;">
          {{"SYSTEM.SYSTEMMANAGEMENT.FINALSTATUS" | translate}}
        </div>
      </div>

      <div class="row justify-content-center align-items-center p-1 p-md-2">
        <div class="col-12 p-0" style="max-width: 1400px;">
          <table mat-table [dataSource]="systemStatusList" class="mat-elevation-z8">
            <!-- Colonna Data -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> {{"SYSTEM.READONLY.TABLE.DATE" | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{ element.message_date | date:'dd/MM/yyyy' }} </td>
            </ng-container>

            <!-- Colonna Stato -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> {{"SYSTEM.READONLY.TABLE.STATUS" | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <i class="bi bi-circle-fill me-1" [ngStyle]="{'color':  '#'+element.color}"></i>
                {{ element.name }}
              </td>
            </ng-container>

            <!-- Colonna Commento -->
            <ng-container matColumnDef="message">
              <th mat-header-cell *matHeaderCellDef> {{"SYSTEM.READONLY.TABLE.MESSAGE" | translate}} </th>
              <td mat-cell *matCellDef="let element">
                {{ element.message }}
              </td>
            </ng-container>

            <!-- Header e righe della tabella -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
